import { Grid, Stack, styled } from '@mui/material'
import React, { Fragment } from 'react'
import { useAction } from '../../containers/memberModifyUser/memberModifyUserService'
import { translate } from '../../i18n'
import { AttentionLabel } from '../components/common/attentionLabel'
import { BottomButtonGroup } from '../components/common/bottomButtonGroup'
import { BackButton } from '../components/common/buttons/backButton'
import { ButtonL } from '../components/common/buttons/buttonL'
import { ButtonOutlinedS } from '../components/common/buttons/buttonOutlinedS'
import { FlexboxRowTop, Separator } from '../components/common/flexboxes'
import { Form } from '../components/common/inputs/form'
import { RadioButtonGroup } from '../components/common/inputs/radioButtonGroup'
import { TelTextBox } from '../components/common/inputs/telTextBox'
import { TextBox } from '../components/common/inputs/textBox'
import { SubTitle } from '../components/common/subTitle'
import { TimerequiredUnit } from '../components/common/account/timerequiredUnit'
import { Flag, yesNo } from '../../containers/common/constant/classification'
import { GetCategoryMstDto } from '../../dataAccess/webApi/dto/categoryMstDto'
import { USER_EMERGENCY_CONTACT1_CATEGORY_KEY, USER_EMERGENCY_CONTACT2_CATEGORY_KEY, USER_EMERGENCY_CONTACT3_CATEGORY_KEY, USER_SPOUSE_CATEGORY_KEY } from '../components/common/member/userContent'

const UserContentAttribute = styled(Grid)({
  padding: '0 0 0 3rem',
})


export const MemberModifyUser = () => {
  const {
    formMethods,
    autoCompleteAddress,
    onSubmit,
    isDisabledResidenceCategory,
    residenceCategories,
    isDisabledAddress1 ,
    residenceCategoryMst,
    categoryMap
  } = useAction()

  const isNoData = (keys: string[], categoryMap?: {[key:string]: GetCategoryMstDto}) => {
    if (!categoryMap) return true
    const targetCategories = Object.values(categoryMap).filter((value) => keys.includes(value.category) && value.displayCitizen === Flag.ON)
    if (targetCategories == null || targetCategories.length === 0) {
      return true
    } else {
      return false
    }
  }

  return (
    <Form formMethods={formMethods} onSubmit={onSubmit}>
      <Stack spacing={2}>
        <Grid container>
          <Grid item md={3}></Grid>
          <Grid item xs={12} md={6}>
            <Stack spacing={2}>
              {/* 基本 */}
              <SubTitle title={translate('memberModifyUser.title.basic')} />
              <div>
                <UserContentAttribute container rowSpacing={3}>
                  <Grid item xs={12} container>
                    <Grid item xs={12}>
                      <AttentionLabel>*</AttentionLabel>
                      {translate('memberModifyUser.label.name')}
                    </Grid>
                    <Grid item xs={12}>
                      <TextBox
                        name="name"
                        label={translate('memberModifyUser.label.name')}
                        maxLength={100}
                        textType="name"
                        required
                      />
                    </Grid>
                  </Grid>

                  <Grid item xs={12} container>
                    <Grid item xs={12}>
                      <AttentionLabel>*</AttentionLabel>
                      {translate('memberModifyUser.label.kana')}
                    </Grid>
                    <Grid item xs={12}>
                      <TextBox
                        name="kana"
                        label={translate('memberModifyUser.label.kana')}
                        maxLength={100}
                        textType="nameKana"
                        required
                      />
                    </Grid>
                  </Grid>

                  <Grid item xs={12} container>
                    <Grid item xs={12}>
                      <AttentionLabel>*</AttentionLabel>
                      {translate('memberModifyUser.label.postalCode')}
                    </Grid>
                    <Grid item xs={12}>
                      <FlexboxRowTop>
                        <TextBox
                          name="postalCode"
                          label={translate('memberModifyUser.label.postalCode')}
                          textType="postalCode"
                          maxLength={8}
                          required
                        />
                        <Separator />
                        <ButtonOutlinedS onClick={autoCompleteAddress}>
                          {translate('memberModifyUser.button.autoComplete')}
                        </ButtonOutlinedS>
                      </FlexboxRowTop>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} container>
                    <Grid item xs={12}>
                      <AttentionLabel>*</AttentionLabel>
                      {translate('memberModifyUser.label.prefecturesAndMunicipalities')}
                    </Grid>
                    <Grid item xs={12}>
                      <TextBox
                        name="address1"
                        label={translate('memberModifyUser.label.prefecturesAndMunicipalities')}
                        maxLength={100}
                        required
                        disabled={isDisabledAddress1}
                      />
                    </Grid>
                  </Grid>

                  <Grid item xs={12} container>
                    <Grid item xs={12}>
                      <AttentionLabel>*</AttentionLabel>
                      {translate('memberModifyUser.label.address')}
                    </Grid>
                    <Grid item xs={12}>
                      <TextBox
                        name="address2"
                        label={translate('memberModifyUser.label.address')}
                        maxLength={100}
                        required
                      />
                    </Grid>
                  </Grid>

                  <Grid item xs={12} container>
                    <Grid item xs={12}>
                      {translate('memberModifyUser.label.buildingNameRoomNumber')}
                    </Grid>
                    <Grid item xs={12}>
                      <TextBox
                        name="buildingNameRoomNumber"
                        label={translate('memberModifyUser.label.buildingNameRoomNumber')}
                        maxLength={100}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} container>
                    <Grid item xs={12}>
                      <AttentionLabel>*</AttentionLabel>
                      {translate('memberModifyUser.label.residenceCategory')}
                    </Grid>
                    <Grid item xs={12}>
                      <RadioButtonGroup
                        name="residenceCategory"
                        label={translate('memberModifyUser.label.residenceCategory')}
                        required
                        row
                        buttonValueLabels={residenceCategories}
                        disabled={isDisabledResidenceCategory}
                      />
                    </Grid>
                    <div style={{ whiteSpace: 'pre-wrap' }}>
                      {residenceCategoryMst?.descriptionForResidenceCategory &&
                        <AttentionLabel>{residenceCategoryMst.descriptionForResidenceCategory}</AttentionLabel>
                      }
                    </div>
                  </Grid>
                  <Grid item xs={12} container>
                    <Grid item xs={12}>
                      {translate('memberModifyUser.label.relationship')}
                    </Grid>
                    <Grid item xs={12}>
                      <TextBox
                        name="relationship"
                        label={translate('memberModifyUser.label.relationship')}
                        maxLength={50}
                      />
                    </Grid>
                  </Grid>
                  {categoryMap?.timeRequired && categoryMap?.timeRequired.displayCitizen === Flag.ON &&
                    <>
                      <Grid item xs={12} container>
                        <Grid item xs={12}>
                          {categoryMap?.timeRequired.required === yesNo.yes && (
                            <AttentionLabel>*</AttentionLabel>
                          )}
                          {categoryMap?.timeRequired.altCategoryName ?? categoryMap?.timeRequired.name}
                        </Grid>
                        <Grid item xs={12}>
                          <TimerequiredUnit
                            name="timeRequired"
                            hourMax={3}
                            hourMin={0}
                            required={categoryMap?.timeRequired.required === yesNo.yes}
                            control={formMethods.control}
                          />
                        </Grid>
                      </Grid>
                    </>
                  }

                </UserContentAttribute>
              </div>

              {/* 配偶者情報 */}
              {categoryMap?.spouse && categoryMap?.spouse.displayCitizen === Flag.ON && !isNoData(USER_SPOUSE_CATEGORY_KEY, categoryMap) &&
                <>
                  <SubTitle title={translate('memberModifyUser.title.spouse')} />
                  <div>
                    <UserContentAttribute container rowSpacing={3}>
                    {categoryMap?.spouseName && categoryMap?.spouseName.displayCitizen === Flag.ON &&
                        <>
                          <Grid item xs={12} container>
                            <Grid item xs={12}>
                              {categoryMap?.spouseName.required === yesNo.yes && (
                                <AttentionLabel>*</AttentionLabel>
                              )}
                              {categoryMap?.spouseName.altCategoryName ?? categoryMap?.spouseName.name}
                            </Grid>
                            <Grid item xs={12}>
                              <TextBox
                                name="spouseName"
                                label={categoryMap?.spouseName.altCategoryName ?? categoryMap?.spouseName.name} // 氏名
                                textType="name"
                                maxLength={100}
                                required={categoryMap?.spouseName.required === yesNo.yes}
                              />
                            </Grid>
                          </Grid>
                        </>
                      }
                      {categoryMap?.spouseKana && categoryMap?.spouseKana.displayCitizen === Flag.ON &&
                        <>
                          <Grid item xs={12} container>
                            <Grid item xs={12}>
                              {categoryMap?.spouseKana.required === yesNo.yes && (
                                <AttentionLabel>*</AttentionLabel>
                              )}
                              {categoryMap?.spouseKana.altCategoryName ?? categoryMap?.spouseKana.name}
                            </Grid>
                            <Grid item xs={12}>
                              <TextBox
                                name="spouseKana"
                                label={translate('memberModifyUser.label.kana')} // フリガナ
                                maxLength={100}
                                required={categoryMap?.spouseKana.required === yesNo.yes}
                                textType="nameKana"
                              />
                            </Grid>
                          </Grid>
                        </>
                      }
                      {categoryMap?.spouseTel && categoryMap?.spouseTel.displayCitizen === Flag.ON &&
                        <>
                          <Grid item xs={12} container>
                            <Grid item xs={12}>
                              {categoryMap?.spouseTel.required === yesNo.yes && (
                                <AttentionLabel>*</AttentionLabel>
                              )}
                              {categoryMap?.spouseTel.altCategoryName ?? categoryMap?.spouseTel.name}
                            </Grid>
                            <Grid item xs={12}>
                              <TelTextBox
                                name="spouseTel"
                                label={translate('memberModifyUser.label.tel')} // 電話番号
                                required={categoryMap?.spouseTel.required === yesNo.yes}
                              />
                            </Grid>
                          </Grid>
                        </>
                      }
                      {categoryMap?.spouseEmail && categoryMap?.spouseEmail.displayCitizen === Flag.ON &&
                        <>
                          <Grid item xs={12} container>
                            <Grid item xs={12}>
                              {categoryMap?.spouseEmail.required === yesNo.yes && (
                                <AttentionLabel>*</AttentionLabel>
                              )}
                              {categoryMap?.spouseEmail.altCategoryName ?? categoryMap?.spouseEmail.name}
                            </Grid>
                            <Grid item xs={12}>
                              <TextBox
                                name="spouseEmail"
                                label={translate('memberModifyUser.label.email')} // メールアドレス
                                maxLength={320}
                                required={categoryMap?.spouseEmail.required === yesNo.yes}
                              />
                            </Grid>
                          </Grid>
                        </>
                      }
                      {categoryMap?.spouseRelationship && categoryMap?.spouseRelationship.displayCitizen === Flag.ON &&
                        <>
                          <Grid item xs={12} container>
                            <Grid item xs={12}>
                              {categoryMap?.spouseRelationship.required === yesNo.yes && (
                                <AttentionLabel>*</AttentionLabel>
                              )}
                              {categoryMap?.spouseRelationship.altCategoryName ?? categoryMap?.spouseRelationship.name}
                            </Grid>
                            <Grid item xs={12}>
                              <TextBox
                                name="spouseRelationship"
                                label={translate('memberModifyUser.label.relationship')} // お子さまからみた続柄
                                maxLength={100}
                                required={categoryMap?.spouseRelationship.required === yesNo.yes}
                              />
                            </Grid>
                          </Grid>
                        </>
                      }
                      {categoryMap?.spouseCompanyName && categoryMap?.spouseCompanyName.displayCitizen === Flag.ON &&
                        <>
                          <Grid item xs={12} container>
                            <Grid item xs={12}>
                              {categoryMap?.spouseCompanyName.required === yesNo.yes && (
                                <AttentionLabel>*</AttentionLabel>
                              )}
                              {categoryMap?.spouseCompanyName.altCategoryName ?? categoryMap?.spouseCompanyName.name}
                            </Grid>
                            <Grid item xs={12}>
                              <TextBox
                                name="spouseCompanyName"
                                label={translate('memberModifyUser.label.spouseCompanyName')} // 勤務先名称
                                maxLength={100}
                                required={categoryMap?.spouseCompanyName.required === yesNo.yes}
                              />
                            </Grid>
                          </Grid>
                        </>
                      }
                      {categoryMap?.spouseCompanyAddress && categoryMap?.spouseCompanyAddress.displayCitizen === Flag.ON &&
                        <>
                          <Grid item xs={12} container>
                            <Grid item xs={12}>
                              {categoryMap?.spouseCompanyAddress.required === yesNo.yes && (
                                <AttentionLabel>*</AttentionLabel>
                              )}
                              {categoryMap?.spouseCompanyAddress.altCategoryName ?? categoryMap?.spouseCompanyAddress.name}
                            </Grid>
                            <Grid item xs={12}>
                              <TextBox
                                name="spouseCompanyAddress"
                                label={translate('memberModifyUser.label.spouseCompanyAddress')} // 勤務先住所
                                maxLength={100}
                                required={categoryMap?.spouseCompanyAddress.required === yesNo.yes}
                              />
                            </Grid>
                          </Grid>
                        </>
                      }
                      {categoryMap?.spouseCompanyTel && categoryMap?.spouseCompanyTel.displayCitizen === Flag.ON &&
                        <>
                          <Grid item xs={12} container>
                            <Grid item xs={12}>
                              {categoryMap?.spouseCompanyTel.required === yesNo.yes && (
                                <AttentionLabel>*</AttentionLabel>
                              )}
                              {categoryMap?.spouseCompanyTel.altCategoryName ?? categoryMap?.spouseCompanyTel.name}
                            </Grid>
                            <Grid item xs={12}>
                              <TelTextBox
                                name="spouseCompanyTel"
                                label={translate('memberModifyUser.label.spouseCompanyTel')} // 勤務先電話番号
                                required={categoryMap?.spouseCompanyTel.required === yesNo.yes}
                              />
                            </Grid>
                          </Grid>
                        </>
                      }
                      {categoryMap?.spouseTimeRequired && categoryMap?.spouseTimeRequired.displayCitizen === Flag.ON &&
                        <>
                          <Grid item xs={12} container>
                            <Grid item xs={12}>
                              {categoryMap?.spouseTimeRequired.required === yesNo.yes && (
                                <AttentionLabel>*</AttentionLabel>
                              )}
                              {categoryMap?.spouseTimeRequired.altCategoryName ?? categoryMap?.spouseTimeRequired.name}
                            </Grid>
                            <Grid item xs={12}>
                              <TimerequiredUnit
                                name="spouseTimeRequired"
                                hourMax={3}
                                hourMin={0}
                                control={formMethods.control}
                                required={categoryMap?.spouseTimeRequired.required === yesNo.yes}
                              />
                            </Grid>
                          </Grid>
                        </>
                      }
                    </UserContentAttribute>
                  </div>
                </>
              }

              {/* 緊急連絡先１～３ */}
              {['1', '2', '3'].map((suffix) => {
                let targetKeys: string[] = []
                if (suffix==='1') {
                  targetKeys = USER_EMERGENCY_CONTACT1_CATEGORY_KEY
                }
                if (suffix==='2') {
                  targetKeys = USER_EMERGENCY_CONTACT2_CATEGORY_KEY
                }
                if (suffix==='3') {
                  targetKeys = USER_EMERGENCY_CONTACT3_CATEGORY_KEY          
                }

                if (!isNoData(targetKeys, categoryMap)) {
                  return (
                    <Fragment key={suffix}>
                    <SubTitle title={translate(`memberModifyUser.title.emergencyContact${suffix}`)} />
                    <div>
                      <UserContentAttribute container rowSpacing={3}>
                      {categoryMap && categoryMap[`emergencyContactName${suffix}`] && categoryMap[`emergencyContactName${suffix}`]?.displayCitizen === Flag.ON &&
                          <>
                            <Grid item xs={12} container>
                              <Grid item xs={12}>
                                {categoryMap[`emergencyContactName${suffix}`].required === yesNo.yes && (
                                  <AttentionLabel>*</AttentionLabel>
                                )}
                                {categoryMap[`emergencyContactName${suffix}`].altCategoryName ?? categoryMap[`emergencyContactName${suffix}`].name}
                              </Grid>
                              <Grid item xs={12}>
                                <TextBox
                                  name={`emergencyContactName${suffix}`}
                                  label={categoryMap[`emergencyContactName${suffix}`].altCategoryName ?? categoryMap[`emergencyContactName${suffix}`].name}
                                  textType="name"
                                  maxLength={100}
                                  required={categoryMap[`emergencyContactName${suffix}`].required === yesNo.yes}
                                />
                              </Grid>
                            </Grid>
                          </>
                        }
                        {categoryMap && categoryMap[`emergencyContactKana${suffix}`] && categoryMap[`emergencyContactKana${suffix}`]?.displayCitizen === Flag.ON &&
                          <>
                            <Grid item xs={12} container>
                              <Grid item xs={12}>
                                {categoryMap[`emergencyContactKana${suffix}`].required === yesNo.yes && (
                                  <AttentionLabel>*</AttentionLabel>
                                )}
                                {categoryMap[`emergencyContactKana${suffix}`].altCategoryName ?? categoryMap[`emergencyContactKana${suffix}`].name}
                              </Grid>
                              <Grid item xs={12}>
                                <TextBox
                                  name={`emergencyContactKana${suffix}`}
                                  label={translate('memberModifyUser.label.kana')}
                                  maxLength={100}
                                  textType="nameKana"
                                  required={categoryMap[`emergencyContactKana${suffix}`].required === yesNo.yes}
                                />
                              </Grid>
                            </Grid>
                          </>
                        }
                        {categoryMap && categoryMap[`emergencyContactRelationship${suffix}`] && categoryMap[`emergencyContactRelationship${suffix}`]?.displayCitizen === Flag.ON &&
                          <>
                            <Grid item xs={12} container>
                              <Grid item xs={12}>
                                {categoryMap[`emergencyContactRelationship${suffix}`].required === yesNo.yes && (
                                  <AttentionLabel>*</AttentionLabel>
                                )}
                                {categoryMap[`emergencyContactRelationship${suffix}`].altCategoryName ?? categoryMap[`emergencyContactRelationship${suffix}`].name}
                              </Grid>
                              <Grid item xs={12}>
                                <TextBox
                                  name={`emergencyContactRelationship${suffix}`}
                                  label={translate('memberModifyUser.label.relationship')}
                                  maxLength={50}
                                  required={categoryMap[`emergencyContactRelationship${suffix}`].required === yesNo.yes}
                                />
                              </Grid>
                            </Grid>
                          </>
                        }
                        {categoryMap && categoryMap[`emergencyContactCompany${suffix}`] && categoryMap[`emergencyContactCompany${suffix}`]?.displayCitizen === Flag.ON &&
                          <>
                            <Grid item xs={12} container>
                              <Grid item xs={12}>
                                {categoryMap[`emergencyContactCompany${suffix}`].required === yesNo.yes && (
                                  <AttentionLabel>*</AttentionLabel>
                                )}
                                {categoryMap[`emergencyContactCompany${suffix}`].altCategoryName ?? categoryMap[`emergencyContactCompany${suffix}`].name}
                              </Grid>
                              <Grid item xs={12}>
                                <TextBox
                                  name={`emergencyContactCompany${suffix}`}
                                  label={translate('memberModifyUser.label.company')}
                                  maxLength={50}
                                  required={categoryMap[`emergencyContactCompany${suffix}`].required === yesNo.yes}
                                />
                              </Grid>
                            </Grid>
                          </>
                        }
                        {categoryMap && categoryMap[`emergencyContactAddress${suffix}`] && categoryMap[`emergencyContactAddress${suffix}`]?.displayCitizen === Flag.ON &&
                          <>
                            <Grid item xs={12} container>
                              <Grid item xs={12}>
                                {categoryMap[`emergencyContactAddress${suffix}`].required === yesNo.yes && (
                                  <AttentionLabel>*</AttentionLabel>
                                )}
                                {categoryMap[`emergencyContactAddress${suffix}`].altCategoryName ?? categoryMap[`emergencyContactAddress${suffix}`].name}
                              </Grid>
                              <Grid item xs={12}>
                                <TextBox
                                  name={`emergencyContactAddress${suffix}`}
                                  label={translate('memberModifyUser.label.companyAddress')}
                                  maxLength={100}
                                  required={categoryMap[`emergencyContactAddress${suffix}`].required === yesNo.yes}
                                />
                              </Grid>
                            </Grid>
                          </>
                        }
                        {categoryMap && categoryMap[`emergencyContactTel${suffix}`] && categoryMap[`emergencyContactTel${suffix}`]?.displayCitizen === Flag.ON &&
                          <>
                            <Grid item xs={12} container>
                              <Grid item xs={12}>
                                {categoryMap[`emergencyContactTel${suffix}`].required === yesNo.yes && (
                                  <AttentionLabel>*</AttentionLabel>
                                )}
                                {categoryMap[`emergencyContactTel${suffix}`].altCategoryName ?? categoryMap[`emergencyContactTel${suffix}`].name}
                              </Grid>
                              <Grid item xs={12}>
                                <TelTextBox
                                  name={`emergencyContactTel${suffix}`}
                                  label={translate('memberModifyUser.label.tel')}
                                  required={categoryMap[`emergencyContactTel${suffix}`].required === yesNo.yes}
                                />
                              </Grid>
                            </Grid>
                          </>
                        }
                        {categoryMap && categoryMap[`emergencyContactEmail${suffix}`] && categoryMap[`emergencyContactEmail${suffix}`]?.displayCitizen === Flag.ON &&
                          <>
                            <Grid item xs={12} container>
                              <Grid item xs={12}>
                                {categoryMap[`emergencyContactEmail${suffix}`].required === yesNo.yes && (
                                  <AttentionLabel>*</AttentionLabel>
                                )}
                                {categoryMap[`emergencyContactEmail${suffix}`].altCategoryName ?? categoryMap[`emergencyContactEmail${suffix}`].name}
                              </Grid>
                              <Grid item xs={12}>
                                <TextBox
                                  name={`emergencyContactEmail${suffix}`}
                                  label={translate('memberModifyUser.label.email')}
                                  maxLength={320}
                                  textType="email"
                                  required={categoryMap[`emergencyContactEmail${suffix}`].required === yesNo.yes}
                                />
                              </Grid>
                            </Grid>
                          </>
                        }
                        {categoryMap && categoryMap[`emergencyContactTimeRequired${suffix}`] && categoryMap[`emergencyContactTimeRequired${suffix}`]?.displayCitizen === Flag.ON &&
                          <>
                            <Grid item xs={12} container>
                              <Grid item xs={12}>
                                {categoryMap[`emergencyContactTimeRequired${suffix}`].required === yesNo.yes && (
                                  <AttentionLabel>*</AttentionLabel>
                                )}
                                {categoryMap[`emergencyContactTimeRequired${suffix}`].altCategoryName ?? categoryMap[`emergencyContactTimeRequired${suffix}`].name}
                              </Grid>
                              <Grid item xs={12}>
                                <TimerequiredUnit
                                  name={`emergencyContactTimeRequired${suffix}`}
                                  hourMax={3}
                                  hourMin={0}
                                  control={formMethods.control}
                                  required={categoryMap[`emergencyContactTimeRequired${suffix}`].required === yesNo.yes}
                                />
                              </Grid>
                            </Grid>
                          </>
                        }
                        {categoryMap && categoryMap[`emergencyContactOther${suffix}`] && categoryMap[`emergencyContactOther${suffix}`]?.displayCitizen === Flag.ON &&
                          <>
                            <Grid item xs={12} container>
                              <Grid item xs={12}>
                                {categoryMap[`emergencyContactOther${suffix}`].required === yesNo.yes && (
                                  <AttentionLabel>*</AttentionLabel>
                                )}
                                {categoryMap[`emergencyContactOther${suffix}`].altCategoryName ?? categoryMap[`emergencyContactOther${suffix}`].name}
                              </Grid>
                              <Grid item xs={12}>
                                <TextBox
                                  name={`emergencyContactOther${suffix}`}
                                  label={translate('memberModifyUser.label.other')}
                                  maxLength={1000}
                                  multiline
                                  rows={4}
                                  fullWidth
                                  required={categoryMap[`emergencyContactOther${suffix}`].required === yesNo.yes}
                                />
                              </Grid>
                            </Grid>
                          </>
                        }
                      </UserContentAttribute>
                    </div>
                  </Fragment>  
                  )
                } else {
                  return null
                }
              })}
              {/* 減免 */}
              {/* 減免情報の表示が不要となったので一旦コメントアウト
              <SubTitle title={translate('memberModifyUser.title.exempt')} />
              <div>
                <UserContentAttribute container rowSpacing={3}>
                  <Grid item xs={12}>
                    {translate('memberModifyUser.text.exempt')}
                  </Grid>
                </UserContentAttribute>
              </div>
              */}
            </Stack>
          </Grid>
          <Grid item md={3}></Grid>
        </Grid>

        <BottomButtonGroup>
          <ButtonL fullWidth type="submit">
            {translate('memberModifyUser.button.confirmation')}
          </ButtonL>
          <BackButton />
        </BottomButtonGroup>
      </Stack>
    </Form>
  )
}
